<template>
  <div class="fixed z-[99999999] p-4 m-2 flex flex-col items-center gap-2 bottom-16 right-4 max-w-2xl">
    <div
      v-for="toastEvent in events"
      :key="toastEvent.id"
      :class="[
        'p-4 rounded-lg shadow-lg flex items-center gap-2',
        positionClass[toastEvent.position],
        variantClass[toastEvent.variant],
        toastEvent.toastClass,
      ]"
    >
      <!-- Optional Icon -->
      <span v-if="toastEvent.showIcon && toastEvent.icon" :class="toastEvent.iconClass">
        <i :class="toastEvent.icon"></i>
      </span>

      <!-- Toast Message -->
      <span>{{ toastEvent.toastMessage }}</span>

      <!-- Optional Close Button -->
      <button
        v-if="false"
        :class="toastEvent.closeButtonClass || 'ms-4 text-white font-bold'"
      >
        <CircleX class="w-5 h-5" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
// Import Vue Packages
import { ref } from 'vue'
import { eventEmitter } from 'src/utils/eventsEmitters'

// Interfaces
interface ToastEvent {
  id: number,
  toastMessage: string
  duration?: number
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  autoClose?: boolean
  closeButton?: boolean
  showIcon?: boolean
  toastClass?: string
  icon?: string
  closeButtonClass?: string
  iconClass?: string
  variant: 'success' | 'error' | 'warning' | 'info'
}

// Variables
let startId = 0
const queue = ref<Array<ToastEvent>>([])
const events = ref<Array<ToastEvent>>([])
const positionClass: any = ref({
  'top-left': 'top-4 left-4',
  'top-right': 'top-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'bottom-right': 'bottom-4 right-4',
})
const variantClass: any = ref({
  success: 'bg-green-600 text-white',
  error: 'bg-red-600 text-white',
  warning: 'bg-yellow-600 text-black',
  info: 'bg-blue-600 text-white',
})

// Functions
const appendToQueue = (props: ToastEvent) => {
  startId += 1
  const event = {
    id: startId,
    toastMessage: props.toastMessage,
    duration: props.duration || 5000,
    position: props.position || 'bottom-right',
    autoClose: props.autoClose,
    closeButton: props.closeButton,
    showIcon: props.showIcon,
    toastClass: props.toastClass,
    icon: props.icon,
    closeButtonClass: props.closeButtonClass,
    iconClass: props.iconClass,
    variant: props.variant || 'info',
    visible: (queue.value.length > 2)? false: true
  }
  if (events.value.length < 3) {
    events.value.push(event)
    setTimeout(() => {
      removeToast(event.id)
    }, event.duration)
  }
  else {
    queue.value.push(event)
  }
}

const removeToast = (eventId: number) => {
  const index = events.value.findIndex((event: ToastEvent) => event.id == eventId)
  if (index == -1){
    return
  }

  events.value.splice(index, 1)

  triggerNextToast()
}

const triggerNextToast = () => {
  const event = queue.value.splice(0, 1)
  if (event.length > 0) {
    events.value.push(event[0])
    setTimeout(() => {
      removeToast(event[0].id)
    }, event[0].duration)
  }
}

eventEmitter.on('toast-emit', (data: string) => {
  const props: ToastEvent = JSON.parse(data)
  appendToQueue(props)
})
</script>

<script lang="ts" setup>
// Import Vue Files
import { CircleX } from 'lucide-vue-next'
</script>
